import image1 from '../assets/images/star_x_vip.png';
const siteOptionData = [
    {
      id: 1,
      siteName: "STARVPN BRAND",
      image: image1,
      description: "Experience a secure and reliable VPN service with enhanced privacy and performance.",
      siteLink: "https://jannatvip.xyz"
    }
  ];
  export default siteOptionData;
